var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center",class:[_vm.params.cellClass, _vm.isDisabled ? 'cursor-not-allowed' : 'cursor-pointer'],attrs:{"title":_vm.title,"aria-label":_vm.ariaLabel,"aria-disabled":_vm.isDisabled ? 'true' : 'false',"role":"button"},on:{"click":_vm.handleClick}},[_c('i',{class:_vm.params.iconClass})])
}
var staticRenderFns = []

export { render, staticRenderFns }